export function FAQSection() {
  const faqs = [
    {
      question: '什么是韩国伦理体系的核心特征？',
      answer: '韩国伦理体系以儒家思想为根基，融合了佛教、基督教等多元文化元素，形成了以"孝"为核心的家族伦理、以"忠"为导向的职场伦理、以"礼"为规范的社交伦理三大支柱。其核心特征体现在重视集体和谐、强调等级尊重、注重人情关系以及追求道德修养等方面。',
    },
    {
      question: '儒家思想对韩国社会的影响有多大？',
      answer: '儒家思想的影响渗透到韩国社会的方方面面。在家庭中表现为孝道文化和家族主义，在教育领域体现在尊师重道和学业竞争，在职场中反映为等级制度和集体主义，在政治领域则影响着民众对清廉和领导力的期待。即便是现代韩国，儒家价值观仍在很大程度上塑造着人们的行为方式和思维模式。',
    },
    {
      question: '韩国职场伦理有哪些独特之处？',
      answer: '韩国职场伦理最显著的特点是严格的等级制度、强烈的集体主义精神和"会食"文化。年龄、职位和入职年限决定了互动方式；团队和谐被视为高于个人表现的价值；下班后的聚餐是职场关系的重要组成部分。不过，MZ世代的崛起正在推动这些传统职场伦理向更加平等和灵活的方向变革。',
    },
    {
      question: '韩国家庭伦理在现代社会发生了哪些变化？',
      answer: '韩国家庭伦理正经历从传统宗族本位到现代个体幸福的转变。核心家庭取代了大家庭、恋爱婚姻取代了媒妁婚姻、女性地位显著提升。同时，单人家庭比例不断上升，"婚否自由"运动获得越来越多认可，家庭形态呈现出前所未有的多元化趋势。孝道也从"同居共财"转向了更加注重情感联系的新模式。',
    },
    {
      question: '韩国的长幼有序制度是如何运作的？',
      answer: '韩国的年龄等级制度通过敬语体系、称呼方式、行为礼仪等多维度运作。韩语有精密的敬语和平语系统，使用错误的语体被视为严重失礼。称呼如"兄""姐""前辈"等精确界定社会关系。在酒桌、餐桌等场合，座次安排、倒酒顺序、用餐次序都严格遵循年龄等级原则。这一制度正在经历从"僵化权威"到"柔性互敬"的渐进演变。',
    },
    {
      question: '如何系统学习韩国伦理文化？',
      answer: '建议从以下路径系统学习：（1）从儒家经典入手了解韩国伦理的思想源头；（2）通过韩国历史理解伦理体系的形成过程；（3）关注当代韩国社会议题把握伦理观念的演变趋势；（4）结合韩国影视作品和文学作品感受伦理在日常生活中的体现。本站各分类栏目已按照这一学习路径组织内容，可帮助您循序渐进地建立对韩国伦理的系统认知。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="py-14 md:py-20 px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于韩国伦理文化的常见疑问与解答
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-950 list-none">
                {faq.question}
                <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </section>
    </>
  );
}